import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { query } from 'express';
import { CouponcodeService } from 'src/_service/CouponcodeService';
import { GlobalService } from 'src/_service/GlobalService';


@Component({
  selector: 'app-tellafriendresult',
  template: '<h1>You have a nice friend!</h1><p>Enjoy the discount on your Ekomenu box</p>',
  standalone: true
})
export class TellafriendResultComponent implements OnInit {

  constructor(
    public activatedRoute: ActivatedRoute,
    public router: Router,
    private _couponcodeService: CouponcodeService,
    private _globalService: GlobalService
  ) {

  }
  ngOnInit() {

    if (this._globalService.isInBrowser) {
      console.log('here in taf')

      this.activatedRoute.queryParams.pipe(
      ).subscribe(queryParams => {
        console.log(queryParams)
        this._couponcodeService.setCouponcode(queryParams.couponcode, null, queryParams.email.replace(" ", "+"))
        this.router.navigate(['./recipefirst']);

      });
    }

  }

}
